export const server = "https://e-shop-six-mu.vercel.app/api/v2";


